import { Link } from 'react-router-dom'

import type { Bereich } from '../bereiche'

/**
 * Wer einen Bereich öffnet, für den sein Zugang nicht freigegeben ist - über eine alte Adresse, ein
 * Lesezeichen oder weil das Backend mit 403 antwortet -, liest hier einen Satz und den Weg zurück,
 * statt einer roten Meldung auf einer halb leeren Seite.
 */
export default function KeinZugangSeite({ bereich, text }: { bereich: Bereich; text?: string }) {
  return (
    <section className="kein-zugang">
      <h2>Kein Zugang zu diesem Bereich</h2>
      <p>
        Ihr Zugang ist für <b>{bereich.titel}</b> nicht freigegeben.
        {text && text !== `Kein Zugang zum Bereich ${bereich.titel}.` && <span className="hinweis"> ({text})</span>}
      </p>
      <p className="hinweis">Freigeben kann das die Verwaltung unter Verpackungsdisposition · Stammdaten · Einstellungen · Zugänge.</p>
      <p>
        <Link className="knopf" to="/">
          Zur Bereichsauswahl
        </Link>
      </p>
    </section>
  )
}
